import { HttpErrorResponse } from '@angular/common/http';
import { inject } from '@angular/core';
import { OtpService, RegisterService, RegistrationDTO, RequestOtpViaMsisdnDTO } from '@core';
import { patchState, signalStore, withMethods, withState } from '@ngrx/signals';

type RegistrationState = {
  requestingOTP: boolean;
  requestingRegistration: boolean;
  errorMessage: string;
  otpSent: boolean;
  invalidOTP: boolean;
  registered: boolean;
  cardNumber: string;
  fullName: string;
};

const initialState: RegistrationState = {
  errorMessage: '',
  requestingOTP: false,
  requestingRegistration: false,
  otpSent: false,
  invalidOTP: false,
  registered: false,
  cardNumber: '',
  fullName: '',
};

export const RegistrationStore = signalStore(
  { providedIn: 'root' },
  withState(initialState),
  withMethods(
    (store, otpService = inject(OtpService), registerService = inject(RegisterService)) => ({
      resetOtpState() {
        patchState(store, { otpSent: false, errorMessage: '' });
      },

      async requestOtp(otpDTO: RequestOtpViaMsisdnDTO) {
        patchState(store, { requestingOTP: true, otpSent: false, errorMessage: '' });

        try {
          const response = await otpService.requestOtp(otpDTO);
          patchState(store, { requestingOTP: false });

          if (response.success) {
            patchState(store, { otpSent: true });
          } else {
            patchState(store, {
              requestingOTP: false,
              otpSent: false,
            });
          }
        } catch (error) {
          patchState(store, {
            requestingOTP: false,
          });
        }
      },

      async registerUser(registrationDTO: RegistrationDTO) {
        patchState(store, {
          requestingRegistration: true,
          registered: false,
          errorMessage: '',
          invalidOTP: false,
        });

        try {
          const response = await registerService.register(registrationDTO);
          patchState(store, { requestingRegistration: false });
          if (response.success) {
            const fullName = `${registrationDTO.personalInfo?.firstName} ${registrationDTO.personalInfo?.lastName}`;

            patchState(store, {
              registered: true,
              cardNumber: response.cardNumber,
              fullName: fullName,
            });
          } else {
            patchState(store, {
              errorMessage: response.message || 'Registration failed. Please try again.',
            });
          }
        } catch (error) {
          const isInvalidOtp = (error as HttpErrorResponse)?.error?.code === 'InvalidOtpError';

          patchState(store, {
            requestingRegistration: false,
            invalidOTP: isInvalidOtp,
          });
          return;
        }
      },
    })
  )
);
